<template>
  <div id="storeInspectionDetail">
    <div class="commonContainer">
      <p class="title">{{$t('storeInspection.storeDetail')}}</p>

      <p class="detail">
        {{$t('filters.doorName')}}: {{ ruleForm.doorName }}
      </p>
      <p class="detail">
        门店编号: {{ ruleForm.posId }}
      </p>
      <p class="detail">
        {{ ruleForm.info }}
      </p>
      <p class="store-detail">{{ruleForm.regionName}}/{{ruleForm.provinceName}}/{{ruleForm.cityName}}/{{ruleForm.resellerName}}</p>
      <p class="subTitle title">{{ruleForm.typeName}}</p>

      <el-card shadow="never">
        <el-tag type="danger" class="tag">{{ruleForm.statusName}}</el-tag>
        <p class="detail">{{ ruleForm.chanceDesc }}</p>

        <gallery :images="ruleForm.images" :index="index" @close="index = null"></gallery>
        <div class="imageBox">
          <div
            class="image"
            v-for="(image, imageIndex) in ruleForm.images"
            :key="imageIndex"
            @click="index = imageIndex"
            :style="{ backgroundImage: 'url(' + image + ')', width: '250px', height: '180px' }"
          ></div>
        </div>

      </el-card>

      <div class="center">
        <el-button type="plain" @click="goBack">{{ $t('close') }}</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import VueGallery from 'vue-gallery'
import Cookies from 'js-cookie'

export default {
  name: 'storeInspectionDetail',
  components: {'gallery': VueGallery},
  data: function () {
    return {
      myHeaders: {
        token: Cookies.get('token') || '', // 用户token
      },
      attachmentsUploadUrl: window.uploadUrl,
      id: this.$route.query.id || null,
      initRuleForm: {
        inspectionTime: '', //巡店时间
        storeType: '', //巡店类型
        posId: '000000',
        doorName: '门店名称',
        chanceDesc: '机会点描述', //机会点描述
        info: '大北京/北京/北京/topsports',
        images: [
          'https://placeholder.im/300x200/cccccc',
          'https://placeholder.im/300x200/cccccc',
          'https://placeholder.im/300x200/cccccc',
        ]
      },
      ruleForm: {

      },
      index: null,
      loading: false,
      formLabelWidth: '120px',
      typeOptions: [],
      inspectionTitle: '',
    }
  },
  async mounted () {
    if (this.id == null) {
      this.ruleForm = _.cloneDeep(this.initRuleForm)
    } else {
      await this.getData()
    }
    await this.getTypeOptions()
  },

  methods: {

    async getTypeOptions() {
      let res = await window.instance.post(window.retailinkUrl + '/mqApi/systemType')
      res = res.data
      if (res.code === 200) {
        this.typeOptions = _.map(res.data, (type) => ({
          key: type.desc,
          value: type.code
        }))
      }
    },

    async getData(id) {
      let res = await window.instance.post(topdoorReqUrl + '/inspection/detail/' + this.id)
      res = res.data
      if (res.code === 200) {
        this.ruleForm = _.cloneDeep(res.data)

        // 获取图片列表的代码
        // const fileList = []
        // _.each(this.ruleForm.images, (img) => {
        //   fileList.push({
        //     name: '',
        //     url: img
        //   })
        // })
        // this.ruleForm.images = fileList
        console.log('....image...', this.ruleForm.images)
      }
    },

    goBack() {
      window.close()
    },
  }
}
</script>

<style>
.hide-upload .el-upload--picture-card {
  display: none;
}
.el-upload-list__item {
  transition: none !important; /* 完全禁用过渡效果 */
}
</style>
<style scoped lang="sass">
#storeInspectionDetail
  .detail
    font-size: 14px
  .center
    text-align: center
    margin-top: 50px
  .tip
    color: red
    display: inline-block
    margin-top: 10px
  .title
    font-size: 16px
    margin-bottom: 40px
  .subTitle
    margin-top: 20px
    margin-bottom: 12px
  .tag
    margin-top: -40px
    margin-left: -20px
    position: relative
    top: -14px
  .imageBox::after
    content: ""
    display: block
    clear: both
  .imageBox
    margin-top: 20px
    .image
      float: left
      background-size: cover
      background-repeat: no-repeat
      background-position: center center
      border: 1px solid #ebebeb
      margin: 5px

</style>



// WEBPACK FOOTER //
// src/topdoor/pages/storeInspection/storeInspectionDetail.vue